import { ReactNode } from 'react'

const isBrowser = typeof window !== 'undefined'

export interface BrowserOnlyProps {
  children: ReactNode
}

const BrowserOnly = ({ children }: BrowserOnlyProps): JSX.Element => {
  if (isBrowser) {
    return <>{children}</>
  } else {
    return <></>
  }
}

export default BrowserOnly
